module.exports = __webpack_public_path__ + "484f576b88492c19de56343d8a44c4fd.png";